<div class="toolbar">
  <div class="toolbar__logo" [class.is-collapsed]="sidebar.collapsed">
    <div class="logo-rail">
      <img
        src="assets/images/ministry-logo.svg"
        alt="Ministry of Rural Development"
        class="ministry-logo"
      />
      <img
        src="assets/images/ministry-emblem.svg"
        alt="Ministry of Rural Development"
        class="ministry-emblem"
      />
      <button
        type="button"
        class="sidebar-toggle"
        [class.is-collapsed]="sidebar.collapsed"
        (click)="sidebar.toggle()"
        [attr.aria-label]="(sidebar.collapsed ? 'expandMenu' : 'collapseMenu') | translate"
        [attr.aria-expanded]="!sidebar.collapsed"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 6H20M8 12H20M8 18H20" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <path d="M5 9L2 12L5 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <span class="clf-brand">
    <img src="assets/images/clf-unite-logo.png" alt="CLF-UNITe" class="clf-logo-full clf-logo-full--light" />
    <img src="assets/images/clf-unite-logo-dark.png" alt="CLF-UNITe" class="clf-logo-full clf-logo-full--dark" />
  </span>
  </div>

  @if (isLoggedIn) {
    <div class="toolbar__right">
      <button
        type="button"
        class="header-bell"
        (click)="onBellClick($event)"
        aria-label="Notifications"
      >
        <img src="assets/images/bell.svg" alt="Notifications" />
      </button>
      <span class="header-sep"></span>
    <div class="user-profile" (click)="toggleMenu($event)">
      <img
        class="profile-img"
        [src]="profileImageSrc"
        #img
        (error)="img.src = 'assets/images/profileLogo.svg'"
        alt="profile"
      />
      <div class="profile-desc">
        <span class="user-name">{{ userProfile?.name }}</span>
        @if (selectedRole) {
          <span class="user-role">{{ selectedRole.label }}</span>
        }
      </div>
      <img
        class="profile-arrow"
        src="assets/images/Dropdown_Icon.svg"
        alt="arrow down"
      />
      @if (menuOpen) {
        <div class="profile-menu" (click)="$event.stopPropagation()">
          @if (availableRoles.length) {
            <button type="button" class="menu-row" (click)="toggleRoles($event)">
              <svg class="menu-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" stroke="#475467" stroke-width="2"/>
                <path d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z" stroke="#475467" stroke-width="2"/>
              </svg>
              <span class="menu-label">{{ 'roles' | translate }}</span>
              @if (canSwitchRole) {
                <span class="menu-chevron" [class.is-open]="rolesOpen">&#8250;</span>
              }
            </button>
            @if (rolesOpen || !canSwitchRole) {
              <div class="menu-sub">
                @for (role of availableRoles; track role.code) {
                  <button
                    type="button"
                    class="menu-sub-item"
                    [class.is-active]="role.code === selectedRole?.code"
                    (click)="onSelectRole(role, $event)"
                  >
                    {{ role.label }}
                  </button>
                }
              </div>
            }
          }
          <button type="button" class="menu-row" (click)="toggleSupport($event)">
            <svg class="menu-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12" stroke="#475467" stroke-width="2" stroke-linecap="round"/>
              <path d="M4 14C4 12.8954 4.89543 12 6 12C7.10457 12 8 12.8954 8 14V16C8 17.1046 7.10457 18 6 18C4.89543 18 4 17.1046 4 16V14Z" stroke="#475467" stroke-width="2"/>
              <path d="M16 14C16 12.8954 16.8954 12 18 12C19.1046 12 20 12.8954 20 14V16C20 17.1046 19.1046 18 18 18C16.8954 18 16 17.1046 16 16V14Z" stroke="#475467" stroke-width="2"/>
              <path d="M19 17V18C19 19.6569 17.6569 21 16 21H13" stroke="#475467" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <span class="menu-label">{{ 'helpSupport' | translate }}</span>
            <span class="menu-chevron" [class.is-open]="supportOpen">&#8250;</span>
          </button>
          @if (supportOpen) {
            <div class="menu-sub">
              <button type="button" class="menu-sub-item" (click)="onTicketSupport($event)">
                {{ 'ticketSupport' | translate }}
              </button>
              <button type="button" class="menu-sub-item" (click)="onEmailSupport($event)">
                {{ 'emailSupport' | translate }}
              </button>
            </div>
          }
          <button type="button" class="menu-row menu-logout" (click)="onLogout()">
            <img src="assets/images/logout.svg" alt="logout" class="menu-icon" />
            <span class="menu-label">{{ 'logout' | translate }}</span>
          </button>
        </div>
      }
    </div>
    </div>
  }
</div>
